import { render, staticRenderFns } from "./serviceSupport.vue?vue&type=template&id=8715a190&scoped=true"
import script from "./serviceSupport.vue?vue&type=script&lang=js"
export * from "./serviceSupport.vue?vue&type=script&lang=js"
import style0 from "./serviceSupport.vue?vue&type=style&index=0&id=8715a190&prod&lang=scss&scoped=true"
import style1 from "./serviceSupport.vue?vue&type=style&index=1&id=8715a190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715a190",
  null
  
)

export default component.exports